<div *ngFor="let project of projects" class="card mt-2 mb-4" style="width: 55rem">
  <div class="row">
    <div class="col-md-7">
      <img
        class="card-img-top"
        [src]="project.image"
        alt="Card image cap"
      />
    </div>

    <div class="col  p-1 parr" >
      <div class="card-body">
        <p class="card-text">
          {{project.desc}}
        </p>
        <a
        target="_blank"
        [href]="project.link"
        class="btn btn-outline-primary btn-block">Ver</a>
      </div>
    </div>
  </div>
</div>
